import { render } from "./TaskList.vue?vue&type=template&id=396ef7f3"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=396ef7f3&lang=scss"

import exportComponent from "/app/tmp/ardia/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__